export const PROJECT_INTEGRATIONS_BOOTSTRAP_CACHE_TTL_MS = 5_000;

interface CacheEntry<T> {
    promise: Promise<T>;
    value?: T;
    hasValue: boolean;
    expiresAt: number;
}

const cache = new Map<string, CacheEntry<unknown>>();

export function getProjectIntegrationsBootstrapCached<T>(
    key: string,
    loader: () => Promise<T> | T,
    options: { ttlMs?: number } = {},
): Promise<T> {
    const now = Date.now();
    const existing = cache.get(key) as CacheEntry<T> | undefined;
    if (existing) {
        if (!existing.hasValue) {
            return existing.promise;
        }
        if (existing.expiresAt > now) {
            return Promise.resolve(existing.value as T);
        }
        cache.delete(key);
    }

    const promise = Promise.resolve()
        .then(loader)
        .then((value) => {
            cache.set(key, {
                promise,
                value,
                hasValue: true,
                expiresAt: Date.now() + (options.ttlMs ?? PROJECT_INTEGRATIONS_BOOTSTRAP_CACHE_TTL_MS),
            });
            return value;
        })
        .catch((error) => {
            cache.delete(key);
            throw error;
        });

    cache.set(key, {
        promise,
        hasValue: false,
        expiresAt: Number.POSITIVE_INFINITY,
    });
    return promise;
}

export function invalidateProjectIntegrationsBootstrapCache(prefix?: string): void {
    if (!prefix) {
        cache.clear();
        return;
    }

    for (const key of cache.keys()) {
        if (key.startsWith(prefix)) {
            cache.delete(key);
        }
    }
}
